'use strict';

var jsonSchema_fakerUpgrade = require('./fakerUpgrade.js');
var jsonSchema_JsonSchemaStandard2AppJsonSchema = require('./JsonSchemaStandard2AppJsonSchema.js');
var jsonSchema_mockUpgrade = require('./mockUpgrade.js');
var jsonSchema_utils = require('./utils.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SchemaParserError = /*#__PURE__*/function (SchemaParserError) {
  SchemaParserError["NotFoundInRefStack"] = "NotFoundInRefStack";
  SchemaParserError["CycleRef"] = "CycleRefBreak";
  SchemaParserError["Unknown"] = "Unknown Error";
  return SchemaParserError;
}(SchemaParserError || {});
function GetRefData(sourceData) {
  var dataSchemaDefinitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // 因为 nullable ref 的实现，所以这里需要进行路径压缩
  // lazyData 操作修改自身属性的
  // childNeedLazyData 子级所需要的 JsonSchema lazyData,
  // 直接在这里进行循环引用的判断。
  var nullable = false;
  var refStack = [];
  var dataType = jsonSchema_utils.getMainType(sourceData);
  if (dataType !== 'ref') {
    return {
      res: {
        RefSourceObject: null,
        RefId: null,
        nullable: jsonSchema_utils.isNullable(sourceData),
        datatype: dataType,
        refStack: refStack
      },
      error: null
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  var _getRef = jsonSchema_utils.getRef(sourceData, dataSchemaDefinitions),
    RefSourceObject = _getRef.RefSourceObject,
    RefId = _getRef.RefId,
    RefTitle = _getRef.RefTitle;
  if (RefSourceObject === null || RefId === null || RefTitle === null) {
    // throw 引用类型栈中找不到变量。
    return {
      res: null,
      error: SchemaParserError.NotFoundInRefStack
    };
  }
  if (nullable || jsonSchema_utils.isNullableRef(sourceData)) {
    nullable = true;
  }
  refStack.push(RefId);
  var cursor = RefSourceObject;
  while (cursor !== null) {
    dataType = jsonSchema_utils.getMainType(cursor);
    if (dataType === 'ref') {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      var _getRef2 = jsonSchema_utils.getRef(cursor, dataSchemaDefinitions),
        _RefSourceObject = _getRef2.RefSourceObject,
        XRefId = _getRef2.RefId;
      if (_RefSourceObject === null || XRefId === null) {
        // throw 引用类型栈中找不到变量。
        return {
          res: null,
          error: SchemaParserError.NotFoundInRefStack
        };
      }
      if (refStack.includes(XRefId)) {
        return {
          res: null,
          error: SchemaParserError.CycleRef
        };
      }
      if (nullable || jsonSchema_utils.isNullableRef(cursor)) {
        nullable = true;
      }
      cursor = _RefSourceObject;
      refStack.push(XRefId);
    } else if (dataType === 'object') {
      return {
        res: {
          RefSourceObject: cursor,
          nullable: nullable || jsonSchema_utils.isNullable(cursor),
          RefId: RefId,
          RefTitle: RefTitle,
          datatype: 'object',
          refStack: refStack
        },
        error: null
      };
    } else {
      return {
        res: {
          RefSourceObject: cursor,
          nullable: nullable || jsonSchema_utils.isNullable(cursor),
          RefId: RefId,
          RefTitle: RefTitle,
          datatype: dataType,
          refStack: refStack
        },
        error: null
      };
    }
  }
  return {
    res: _objectSpread(_objectSpread({}, jsonSchema_utils.getRef(sourceData, dataSchemaDefinitions)), {}, {
      datatype: dataType,
      nullable: jsonSchema_utils.isNullable(sourceData),
      refStack: refStack
    }),
    error: SchemaParserError.Unknown
  };
}

/**
 * 应该保持和 JsonSchemaEditor 渲染逻辑一样的方式
 *
 * @param RootSchema
 * @param RootSchemaId
 * @param dataSchemaDefinitions
 * @returns
 */
function AppJsonSchema2JsonSchemaStandard(RootSchema) {
  var RootSchemaId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var dataSchemaDefinitions = _objectSpread({}, RootSchema.definitions);
  return AppJsonSchema2MockJsonSchema(_objectSpread(_objectSpread({}, RootSchema), {}, {
    definitions: dataSchemaDefinitions
  }), RootSchemaId, options);
}
// todo getMainType 不合适于用于此了
function AppJsonSchema2MockJsonSchema(RootSchema) {
  var RootSchemaId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var transformOptions = _objectSpread({
    enableXAppMock: false,
    enableXAppEnum: false,
    enableMockjsAutoTransformFakerjs: false
  }, options);
  var handledIds = new Set();
  var dataSchemaDefinitions = _objectSpread({}, RootSchema.definitions);
  var _getAllExpendKeys = jsonSchema_utils.getAllExpendKeys(),
    expendRefsKey = _getAllExpendKeys.expendRefsKey,
    expendOrdersKey = _getAllExpendKeys.expendOrdersKey,
    expendIgnorePropertiesKey = _getAllExpendKeys.expendIgnorePropertiesKey,
    expendOverridesKey = _getAllExpendKeys.expendOverridesKey,
    expendEnumDescriptionKey = _getAllExpendKeys.expendEnumDescriptionKey,
    expendMockKey = _getAllExpendKeys.expendMockKey,
    expendKey = _getAllExpendKeys.expendKey;
  function RefSchemaCore(_ref) {
    var draftSchema = _ref.draftSchema,
      schemaId = _ref.schemaId,
      _ref$XOverrides = _ref.XOverrides,
      XOverrides = _ref$XOverrides === void 0 ? {} : _ref$XOverrides,
      XOverridesRequired = _ref.XOverridesRequired,
      _ref$ValidFieldSet = _ref.ValidFieldSet,
      ValidFieldSet = _ref$ValidFieldSet === void 0 ? new Set() : _ref$ValidFieldSet;
    var mainType = jsonSchema_utils.getMainType(draftSchema);
    var RefSourceObject = null;
    if (mainType === 'ref') {
      var _GetRefData = GetRefData(draftSchema, dataSchemaDefinitions),
        res = _GetRefData.res,
        error = _GetRefData.error;
      if (error) {
        // ...
        return {
          RequiredProps: new Set(),
          properties: {},
          XAppIgnoreProperties: [],
          ObjectOrder: []
        };
      }
      RefSourceObject = res === null || res === void 0 ? void 0 : res.RefSourceObject;
    } else if (mainType === 'object') {
      RefSourceObject = draftSchema;
    }
    if (!RefSourceObject) {
      return {
        RequiredProps: new Set(),
        properties: {},
        XAppIgnoreProperties: [],
        ObjectOrder: []
      };
    }
    var _ObjectSchemaCore = ObjectSchemaCore({
        draftSchema: RefSourceObject,
        schemaId: schemaId,
        ValidFieldSet: ValidFieldSet
      }),
      RequiredProps = _ObjectSchemaCore.RequiredProps,
      properties = _ObjectSchemaCore.properties,
      ObjectOrder = _ObjectSchemaCore.ObjectOrder;
    var XOverridesKeys = Object.keys(XOverrides).filter(function (v) {
      return v in properties;
    });
    // const AddFieldList = XOverridesOrder.filter((v) => !HideFieldList.includes(v));
    var ValidXOverridesRequired = new Set(XOverridesRequired === null || XOverridesRequired === void 0 ? void 0 : XOverridesRequired.filter(function (v) {
      return XOverridesKeys.includes(v);
    }));
    XOverridesKeys.forEach(function (v) {
      if (XOverrides[v] === null) {
        RequiredProps["delete"](v);
        ValidFieldSet["delete"](v);
        delete properties[v];
      } else {
        // 非引用字段，优先级更高。
        // 原地替换
        ValidFieldSet.add(v);
        properties[v] = SchemaCore({
          draftSchema: XOverrides[v],
          schemaId: schemaId
        });
        if (RequiredProps.has(v) && !ValidXOverridesRequired.has(v)) {
          RequiredProps["delete"](v);
        } else if (!RequiredProps.has(v) && ValidXOverridesRequired.has(v)) {
          RequiredProps.add(v);
        }
      }
    });
    // AddFieldList.forEach((v) => {
    //   RequiredProps.delete(v);
    //   if (XOverrides[v]) {
    //     // 非引用字段，优先级更高。
    //     ValidFieldSet.add(v);
    //     properties[v] = SchemaCore({
    //       draftSchema: XOverrides[v]!,
    //       schemaId,
    //     });
    //     ObjectOrder.push(v);
    //   }
    // });

    return {
      RequiredProps: RequiredProps,
      properties: properties,
      XAppIgnoreProperties: Object.keys(properties),
      ObjectOrder: ObjectOrder
    };
  }
  function ObjectSchemaCore(_ref2) {
    var draftSchema = _ref2.draftSchema,
      schemaId = _ref2.schemaId,
      _ref2$ValidFieldSet = _ref2.ValidFieldSet,
      ValidFieldSet = _ref2$ValidFieldSet === void 0 ? new Set() : _ref2$ValidFieldSet;
    // 同名字段覆盖/展示逻辑：
    // 1. “非引用字段”的优先级高于“引用字段”
    // 2. “同为引用”或“同为非引用”的字段之间的优先级：“排序在前的字段”优先级高于“排序在后的字段”
    // 3. 无效字段的“字段名”显示删除线，tooltip提示“该字段无效，存在同名字段”
    var RequiredProps = new Set(draftSchema.required);
    var OptionalProps = new Set();
    var properties = {};
    var XAppIgnoreProperties = [];
    var ObjectPropertiesList = Object.keys((draftSchema === null || draftSchema === void 0 ? void 0 : draftSchema.properties) || {});
    var ObjectOrder = jsonSchema_JsonSchemaStandard2AppJsonSchema.getActiveXAppOrder(draftSchema);
    ObjectOrder.forEach(function (objKey) {
      if (ObjectPropertiesList.includes(objKey)) {
        ValidFieldSet.add(objKey);
      }
    });
    ObjectOrder.forEach(function (objKey) {
      var _draftSchema$expendRe, _draftSchema$properti;
      var XRefsData = (_draftSchema$expendRe = draftSchema[expendRefsKey]) === null || _draftSchema$expendRe === void 0 ? void 0 : _draftSchema$expendRe[objKey];
      if (XRefsData) {
        var _GetRefData2 = GetRefData(XRefsData, dataSchemaDefinitions),
          res = _GetRefData2.res;
        if (!res) return;
        var SourceRef = res.RefSourceObject,
          RefId = res.RefId;
        if (!SourceRef) return;
        var mainType = jsonSchema_utils.getMainType(SourceRef);
        if (!(mainType === 'object' || mainType === 'ref')) {
          return;
        }
        var RefSourceObject = JSON.parse(JSON.stringify(SourceRef));
        var IncludeCycleDeps = jsonSchema_utils.isIncludeCycleDeps(schemaId, RefId);
        if (IncludeCycleDeps) return;
        var RefSnap = RefSchemaCore({
          draftSchema: RefSourceObject,
          schemaId: [].concat(_toConsumableArray(schemaId), [RefId]),
          XOverrides: XRefsData[expendOverridesKey],
          XOverridesRequired: XRefsData.required
          // ValidFieldSet,
        });
        var activeRefProps = Object.keys(RefSnap.properties).filter(function (k) {
          return !ValidFieldSet.has(k);
        }).reduce(function (activeProps, propsKey) {
          if (RefSnap.properties[propsKey] && !ObjectPropertiesList.includes(propsKey)) {
            // eslint-disable-next-line no-param-reassign
            activeProps[propsKey] = RefSnap.properties[propsKey];
            ValidFieldSet.add(propsKey);
            if (RefSnap.RequiredProps.has(propsKey)) {
              RequiredProps.add(propsKey);
              OptionalProps["delete"](propsKey);
            } else {
              OptionalProps.add(propsKey);
              RequiredProps["delete"](propsKey);
            }
          }
          return activeProps;
        }, {});
        properties = _objectSpread(_objectSpread({}, properties), activeRefProps);
      }
      var subSchemaData = (_draftSchema$properti = draftSchema.properties) === null || _draftSchema$properti === void 0 ? void 0 : _draftSchema$properti[objKey];
      if (subSchemaData) {
        var _draftSchema$required;
        if (subSchemaData['x-tmp-pending-properties']) return;
        var required = !!((_draftSchema$required = draftSchema.required) !== null && _draftSchema$required !== void 0 && _draftSchema$required.includes(objKey));
        properties[objKey] = SchemaCore({
          draftSchema: subSchemaData,
          schemaId: schemaId
        });
        if (required) {
          RequiredProps.add(objKey);
          OptionalProps["delete"](objKey);
        } else {
          RequiredProps["delete"](objKey);
          OptionalProps.add(objKey);
        }
      }
    });
    XAppIgnoreProperties = Object.keys(properties).filter(function (p) {
      return !ObjectPropertiesList.includes(p);
    });
    var isNullableObject = jsonSchema_utils.isNullable(draftSchema);
    var newSchema = _objectSpread(_objectSpread({}, draftSchema), {}, _defineProperty(_defineProperty({
      type: isNullableObject ? ['object', 'null'] : 'object',
      properties: properties,
      required: RequiredProps.size === 0 ? undefined : Array.from(RequiredProps)
    }, expendIgnorePropertiesKey, Array.from(XAppIgnoreProperties)), expendOrdersKey, ObjectOrder));
    // newSchema.properties = reOrderProps(newSchema);
    // eslint-disable-next-line no-param-reassign
    delete newSchema.$ref;
    if (RequiredProps.size === 0) {
      // eslint-disable-next-line no-param-reassign
      delete newSchema.required;
    }
    return {
      schema: newSchema,
      RequiredProps: RequiredProps,
      OptionalProps: OptionalProps,
      properties: properties,
      XAppIgnoreProperties: XAppIgnoreProperties,
      ObjectOrder: ObjectOrder
    };
  }
  function SchemaCore(_ref3) {
    var draftSchema = _ref3.draftSchema,
      schemaId = _ref3.schemaId;
    if (_typeof(draftSchema) !== 'object') return draftSchema;
    if (draftSchema.nullable === true) {
      if (draftSchema.type) {
        var type = (Array.isArray(draftSchema.type) ? draftSchema.type : [draftSchema.type]).filter(function (v) {
          return v !== 'null';
        });
        // eslint-disable-next-line no-param-reassign
        draftSchema.type = [].concat(_toConsumableArray(Array.from(new Set(type))), ['null']);
      } else if (draftSchema.$ref) {
        // eslint-disable-next-line no-param-reassign
        delete draftSchema.nullable;
        var collectSubSchema = _objectSpread({}, draftSchema);
        // emptyAll
        Object.keys(draftSchema).forEach(function (k) {
          // eslint-disable-next-line no-param-reassign
          delete draftSchema[k];
        });
        // eslint-disable-next-line no-param-reassign
        draftSchema.anyOf = [collectSubSchema, {
          type: 'null'
        }];
      } else {
        // eslint-disable-next-line no-param-reassign
        draftSchema.type = 'null';
      }
    }
    if (draftSchema.nullable !== undefined) {
      // eslint-disable-next-line no-param-reassign
      delete draftSchema.nullable;
    }
    var mainType = jsonSchema_utils.getMainType(draftSchema);
    if (_typeof(draftSchema) === 'object' && ('allOf' in draftSchema || 'anyOf' in draftSchema || 'oneOf' in draftSchema)) {
      var operator = function () {
        if ('allOf' in draftSchema) return 'allOf';
        if ('anyOf' in draftSchema) return 'anyOf';
        if ('oneOf' in draftSchema) return 'oneOf';
        return '';
      }();
      if (operator) {
        var _draftSchema$operator;
        return _objectSpread(_objectSpread({}, draftSchema), {}, _defineProperty({}, operator, ((_draftSchema$operator = draftSchema[operator]) === null || _draftSchema$operator === void 0 ? void 0 : _draftSchema$operator.filter(function (item) {
          return _typeof(item) === 'object' && !!item && !Array.isArray(item);
        }).map(function (item) {
          return SchemaCore({
            draftSchema: item,
            schemaId: schemaId
          });
        })) || []));
      }
      return draftSchema;
    }
    // if (!['ref', 'oneOf', 'anyOf', 'allOf', 'object', 'array'].includes(mainType)) {
    //   // string, number, integer, boolean, null, any, not 原样输出
    //   return draftSchema;
    // }
    if (mainType === 'array') {
      return _objectSpread(_objectSpread({}, draftSchema), {}, {
        items: SchemaCore({
          draftSchema: draftSchema.items || jsonSchema_utils.defaultSchema.string(),
          schemaId: schemaId
        })
      });
    }
    if (mainType === 'ref') {
      var _GetRefData3 = GetRefData(draftSchema, dataSchemaDefinitions),
        res = _GetRefData3.res;
      var _ref4 = res || {},
        RefSourceObject = _ref4.RefSourceObject,
        datatype = _ref4.datatype,
        refStack = _ref4.refStack;
      if (res && RefSourceObject && refStack) {
        if (datatype === 'object' && !RefSourceObject[expendIgnorePropertiesKey]) {
          var RefId = refStack[refStack.length - 1];
          if (!handledIds.has(RefId)) {
            handledIds.add(RefId);
            dataSchemaDefinitions[RefId] = ObjectSchemaCore({
              draftSchema: JSON.parse(JSON.stringify(RefSourceObject)),
              schemaId: [].concat(_toConsumableArray(schemaId), _toConsumableArray(refStack))
            }).schema;
          }
          var omitTypeSchema = _objectSpread({}, draftSchema);
          delete omitTypeSchema.type;
          return _objectSpread(_objectSpread({}, omitTypeSchema), {}, {
            $ref: "#/definitions/".concat(RefId),
            definitions: draftSchema.definitions
          });
        }
        if (datatype === 'array') {
          var _RefId = refStack[refStack.length - 1];
          if (!handledIds.has(_RefId)) {
            handledIds.add(_RefId);
            dataSchemaDefinitions[_RefId].items = SchemaCore({
              draftSchema: dataSchemaDefinitions[_RefId].items || jsonSchema_utils.defaultSchema.string(),
              schemaId: [].concat(_toConsumableArray(schemaId), _toConsumableArray(refStack))
            });
          }
        }
      }
      return draftSchema;
    }
    if (mainType === 'object') {
      if (draftSchema[expendIgnorePropertiesKey]) {
        return draftSchema;
      }
      return ObjectSchemaCore({
        draftSchema: draftSchema,
        schemaId: schemaId
      }).schema;
    }

    // ------------------------------- mock 和 enum 字段的处理 -------------------------------
    // !! 这两个值是可以同时出现在数据结构的。但是只是在 新版改完，然后旧版本再修改，然后再也没有使用新版本客户端修改的情况下，这些兼容字段会出现并存的情况。但是新的字段总是有的，旧的字段在新版本打开或者编辑就没有了
    // @depreacted 废弃 {mock: {mock: string}} / {faker: {faker: string}}

    if (transformOptions.enableXAppMock) {
      if ('mock' in draftSchema) {
        var _draftSchema$mock, _draftSchema$mock2, _draftSchema$mock3;
        if (_typeof(draftSchema.mock) === 'object' && (typeof ((_draftSchema$mock = draftSchema.mock) === null || _draftSchema$mock === void 0 ? void 0 : _draftSchema$mock.mock) === 'number' || typeof ((_draftSchema$mock2 = draftSchema.mock) === null || _draftSchema$mock2 === void 0 ? void 0 : _draftSchema$mock2.mock) === 'string' && (_draftSchema$mock3 = draftSchema.mock) !== null && _draftSchema$mock3 !== void 0 && _draftSchema$mock3.mock)) {
          var _draftSchema$expendMo;
          // eslint-disable-next-line no-param-reassign
          (_draftSchema$expendMo = draftSchema[expendMockKey]) !== null && _draftSchema$expendMo !== void 0 ? _draftSchema$expendMo : draftSchema[expendMockKey] = draftSchema.mock.mock;
        }
        // eslint-disable-next-line no-param-reassign
        delete draftSchema.mock;
      }
      if ('faker' in draftSchema) {
        if (typeof draftSchema.faker === 'string' && draftSchema.faker) {
          var _draftSchema$expendMo2;
          // eslint-disable-next-line no-param-reassign
          (_draftSchema$expendMo2 = draftSchema[expendMockKey]) !== null && _draftSchema$expendMo2 !== void 0 ? _draftSchema$expendMo2 : draftSchema[expendMockKey] = jsonSchema_fakerUpgrade.fakerUpgrade(draftSchema.faker);
        }
        // eslint-disable-next-line no-param-reassign
        delete draftSchema.faker;
      }
    }
    if (transformOptions.enableMockjsAutoTransformFakerjs) {
      if (typeof draftSchema[expendMockKey] === 'string') {
        draftSchema[expendMockKey] = jsonSchema_mockUpgrade.mockUpgrade(draftSchema[expendMockKey]);
      }
    }
    if (transformOptions.enableXAppEnum) {
      // @depreacted 废弃 {x-apidog: {enumDescriptions: {"1": 1}}}
      if (Array.isArray(draftSchema["enum"]) && expendKey in draftSchema) {
        var _draftSchema$expendKe;
        if (_typeof(draftSchema[expendKey]) === 'object' && _typeof((_draftSchema$expendKe = draftSchema[expendKey]) === null || _draftSchema$expendKe === void 0 ? void 0 : _draftSchema$expendKe.enumDescriptions) === 'object') {
          var _draftSchema$expendEn;
          // eslint-disable-next-line no-param-reassign
          (_draftSchema$expendEn = draftSchema[expendEnumDescriptionKey]) !== null && _draftSchema$expendEn !== void 0 ? _draftSchema$expendEn : draftSchema[expendEnumDescriptionKey] = draftSchema["enum"].map(function (v) {
            var _draftSchema$expendKe2, _draftSchema$expendKe3;
            return {
              value: v,
              name: '',
              description: (_draftSchema$expendKe2 = (_draftSchema$expendKe3 = draftSchema[expendKey]) === null || _draftSchema$expendKe3 === void 0 || (_draftSchema$expendKe3 = _draftSchema$expendKe3.enumDescriptions) === null || _draftSchema$expendKe3 === void 0 ? void 0 : _draftSchema$expendKe3[String(v)]) !== null && _draftSchema$expendKe2 !== void 0 ? _draftSchema$expendKe2 : ''
            };
          });
        }
        // eslint-disable-next-line no-param-reassign
        delete draftSchema[expendKey];
      }
    }
    return draftSchema;
  }
  return RootSchema.definitions ? _objectSpread(_objectSpread({}, SchemaCore({
    draftSchema: RootSchema,
    schemaId: RootSchemaId
  })), {}, {
    definitions: dataSchemaDefinitions
  }) : SchemaCore({
    draftSchema: RootSchema,
    schemaId: RootSchemaId
  });
}
exports.AppJsonSchema2JsonSchemaStandard = AppJsonSchema2JsonSchemaStandard;
exports.AppJsonSchema2MockJsonSchema = AppJsonSchema2MockJsonSchema;
